import { Head, Link, useForm } from "@inertiajs/react";
import { Button, Card, Checkbox, Flex, Link as RadixLink, Text, TextField } from "@radix-ui/themes";
import type { FormEvent } from "react";

import { AppLayout } from "@/components/app-layout";
import type { SharedProps } from "@/lib/types";

type NewAdminUserProps = SharedProps & {
  roleValues: string[];
};

export default function AdminUsersNew({ auth, roleValues }: NewAdminUserProps) {
  const { data, setData, post, processing, errors } = useForm({
    email: "",
    roles: [] as string[],
  });

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    post("/admin/users");
  }

  function toggleRole(role: string) {
    setData(
      "roles",
      data.roles.includes(role)
        ? data.roles.filter((currentRole) => currentRole !== role)
        : [...data.roles, role],
    );
  }

  return (
    <>
      <Head title="Add User" />
      <AppLayout
        user={auth.user}
        activeModule="weekly_planner"
        onModuleChange={() => {}}
        pageTitle="Add User"
        pageActions={
          <RadixLink asChild size="2">
            <Link href="/admin/users">Back to users</Link>
          </RadixLink>
        }
      >
        <Card className="space-y-4 p-4">
          <form className="space-y-3" onSubmit={submit}>
            <div>
              <Text as="label" size="2" weight="medium">
                Email
              </Text>
              <TextField.Root
                mt="1"
                type="email"
                value={data.email}
                onChange={(event) => setData("email", event.target.value)}
              />
              {errors.email && (
                <Text size="1" color="red">
                  {errors.email}
                </Text>
              )}
            </div>

            <fieldset className="space-y-2">
              <legend>
                <Text as="span" size="2" weight="medium">
                  Roles
                </Text>
              </legend>
              {roleValues.map((role) => (
                <Flex key={role} asChild align="center" gap="2">
                  <label>
                    <Checkbox
                      checked={data.roles.includes(role)}
                      onCheckedChange={() => toggleRole(role)}
                    />
                    <Text size="2">{role.replace("_", " ")}</Text>
                  </label>
                </Flex>
              ))}
            </fieldset>

            <Button type="submit" disabled={processing}>
              Create User
            </Button>
          </form>
        </Card>
      </AppLayout>
    </>
  );
}
